import http from '../../api/http';
import { paramsSend } from '../../utils/util';

/*** 参与活动*/
export const participateActive = (params) => http("get", '/coupon/activity/center/share/join', params)
/**活动详情查看*/
export const queryDetail = (params) => http("get", "/coupon/activity/center/detail", params)
/**根据邀请码查看活动详情*/
export const queryShareCodeDetail = (params) => http("get", "/coupon/activity/center/detail", params)
/**分享活动获取邀请码*/
export const queryShareCode = (params) => http("get", "/coupon/activity/center/share/info", params)
/**参与活动*/
export const activityJoin = (params) => http("post", paramsSend("/coupon/activity/center/share/join", params))
